// extracted by mini-css-extract-plugin
export default {"absolute":"Confirmation_absolute__6Yovo","confirmation":"Confirmation_confirmation__X8WHj","textBlock":"Confirmation_textBlock__cpT-X","buttons":"Confirmation_buttons__Bjjim"};